"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var CfgLanguageListCtl = /** @class */ (function (_super) {
    __extends(CfgLanguageListCtl, _super);
    function CfgLanguageListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.code; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_is_deprecated = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_deprecated; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this._errDialog = errDialog;
        return _this;
    }
    CfgLanguageListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    CfgLanguageListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    CfgLanguageListCtl.prototype.LoadData = function (onDone) {
        var _this = this;
        webAApi_1.ListLanguagesGet.exec({}, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    code: resp.list[i].code,
                    is_deprecated: resp.list[i].is_deprecated,
                    title: resp.list[i].title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CfgLanguageListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddLanguage.exec({
            data: {
                title: data.title,
                code: data.code,
                is_deprecated: data.is_deprecated,
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed: moment(resp.date_added_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                title: data.title,
                code: data.code,
                is_deprecated: data.is_deprecated,
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CfgLanguageListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditLanguage.exec({
                data: {
                    app_language_id: data.key,
                    title: data.title,
                    code: data.code,
                    is_deprecated: data.is_deprecated
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.code = data.code;
                _tmp.is_deprecated = data.is_deprecated;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CfgLanguageListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    CfgLanguageListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteLanguage.exec({ data: { app_language_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CfgLanguageListCtl.prototype.SetIsDeprecated = function (key, IsDeprecated, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetLanguageIsDeprecated.exec({ data: { app_language_id: key, is_deprecated: IsDeprecated } }, function (resp) {
                _tmp.is_deprecated = IsDeprecated;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CfgLanguageListCtl.prototype.SetAllIsDeprecated = function (IsDeprecated, onDone) {
        var _this = this;
        webAApi_1.DoSetAllLanguagesIsDeprecated.exec({ data: { is_deprecated: IsDeprecated } }, function (resp) {
            _this.LoadData(function () {
                _this.Update();
                if (onDone) {
                    onDone();
                }
            });
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return CfgLanguageListCtl;
}(BaseController_1.BaseController));
exports.CfgLanguageListCtl = CfgLanguageListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_language/ctl/CfgLanguageListCtl.ts
// module id = 885
// module chunks = 0